const formCTA = {
  init: function (selector) {
    this.form = document.querySelector(selector);
    this.form?.addEventListener("submit", this.onSubmit);
    return this;
  },
  form: null,
  onSubmit: (e) => {
    e.preventDefault();
  },
  afterSubmit: function (callback) {
    this.onSubmit = callback;
    return this;
  },
  sended: function () {
    document.querySelectorAll(".thank-you-message").forEach((el) => {
      el.classList.add("show");
    });
    document.querySelectorAll('form button[type="submit"]').forEach((el) => {
      el.setAttribute("disabled", true);
    });
    document.dispatchEvent(new CustomEvent("formSended"));
  },
};
const formPopup = {
  init: function (selector) {
    this.form = document.querySelector(selector);
    this.form?.addEventListener("submit", this.onSubmit);
    return this;
  },
  form: null,
  onSubmit: (e) => {
    e.preventDefault();
  },
  afterSubmit: function (callback) {
    this.onSubmit = callback;
    return this;
  },
  sended: function () {
    document.querySelectorAll(".thank-you-message").forEach((el) => {
      el.classList.add("show");
    });
    document.querySelectorAll('form button[type="submit"]').forEach((el) => {
      el.setAttribute("disabled", true);
    });
    document.dispatchEvent(new CustomEvent("formSended"));
  },
};
const formTimeout = {
  init: function (selector) {
    this.form = document.querySelector(selector);
    this.form?.addEventListener("submit", this.onSubmit);
    return this;
  },
  form: null,
  onSubmit: (e) => {
    e.preventDefault();
  },
  afterSubmit: function (callback) {
    this.onSubmit = callback;
    return this;
  },
  sended: function () {
    document.querySelectorAll(".thank-you-message").forEach((el) => {
      el.classList.add("show");
    });
    document.querySelectorAll('form button[type="submit"]').forEach((el) => {
      el.setAttribute("disabled", true);
    });
    document.dispatchEvent(new CustomEvent("formSended"));
  },
};
function getMessage(e, forSheets = false) {
  const dict = {
    name: "Імя",
    phone: "Телефон",
    number: "Телефон",
    email: "Email",
  };
  if (forSheets) {
    const data = {
      Дата: new Date().toLocaleString(),
    };
    [...e.target.querySelectorAll("input:not([type='checkbox'])")]
      .map((input) => {
        return {
          key: dict[input.name] || input.name,
          value: input.value
            .split(" ")
            .join("")
            .split("-")
            .join("")
            .split("(")
            .join("")
            .split(")")
            .join(""),
        };
      })
      .concat(
        Object.entries(getUTM()).map(([key, value]) => {
          return {
            key,
            value,
          };
        })
      )
      .forEach((item) => {
        data[item.key] = item.value;
      });
    const message = JSON.stringify(data);
    return message;
  }
  const message = [...e.target.querySelectorAll("input:not([type='checkbox'])")]
    .map((input) => {
      return `<strong>${dict[input.name] || input.name}</strong>: ${
        input.value
      }`;
    })
    .concat(
      Object.entries(getUTM()).map(([key, value]) => {
        return (value && `<strong>${key}</strong>: ${value}`) || undefined;
      })
    )
    .join("\n");

  return message;
}
function telegram({ id, token } = {}, message = "", callback = () => {}) {
  // Check if message is empty
  if (!message || !id || !token) return;

  // Send message to telegram
  fetch(`https://api.telegram.org/bot${token}/sendMessage`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      chat_id: id,
      text: message,
      parse_mode: "HTML",
    }),
  })
    .then((response) => response.json())
    .then((response) => {
      if (response.ok) {
        callback(response);
      }
    });
}

import { initTimer, load } from "./events/events";

load(() => {
  [
    { form: formCTA, select: "#cta form" },
    { form: formPopup, select: ".backdrop.form form" },
    { form: formTimeout, select: ".backdrop.timeout form" },
  ].forEach(({ form, select }) => {
    form
      .afterSubmit((e) => {
        e.preventDefault();
        form.form.querySelectorAll(".error").forEach((input) => {
          input.classList.remove("error");
        });
        initTimer(
          "awaitingFormValidate",
          () => {
            if (
              !form.form?.querySelector('input[type="checkbox"]')?.checked ||
              form.form.querySelector('input[name="phone"]').value.length <
                12 ||
              form.form.querySelector('input[name="name"]').value.length < 4
            ) {
              [
                { name: "phone", length: 12 },
                { name: "name", length: 4 },
              ].forEach(({ name, length }) => {
                if (
                  form.form.querySelector(`input[name="${name}"]`).value
                    .length < length
                ) {
                  form.form
                    .querySelector(`input[name="${name}"]`)
                    .classList.add("error");
                }
              });
              if (!form.form.querySelector('input[type="checkbox"]').checked) {
                form.form
                  .querySelector('input[type="checkbox"] ~ span')
                  .classList.add("error");
              }
              return;
            }
            const bot = {
              id: "-1002421270615",
              token: "7521393703:AAF92UgSjLacoT060i70krImF8uZlWXDhtw",
            };
            var data = {
              action: "partner-custom-form",
              token: "K8k0ZnCXHmZb2Ds25kTTVbFuWhbhv8q6Ws5uXGNf-Bo",
              partner_id: 19341,
              name: e.target.querySelector('input[name="name"]')?.value,
              phone: e.target.querySelector('input[name="phone"]')?.value,
              lang: "ua",
              note: "Запит з форми контактів",
            };
            console.log(data);

            fetch("https://crm.g-plus.app/api/actions", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(data),
            })
              .then((response) => response.json())
              .then((data) => {
                if (data.success) {
                  console.log("Форма відправлена");
                } else {
                  console.log("Помилка відправлення форми");
                }
              })
              .catch((error) => {
                console.error("Error:", error);
              });
            telegram(bot, getMessage(e), (response) => {});

            sendToSheets(e);
            // Ось тут додаємо виклик твоєї функції
            sendToGPlusCRM(e.target);
            e.target.reset();
            form.sended.bind(form)();
          },
          50
        );
      })
      .init(select);
  });
  setUTM();
  getUTM();
});

function setUTM() {
  if (sessionStorage.getItem("utm")) return;
  const utm = new URLSearchParams(window.location.search);
  const utm_source = utm.get("utm_source");
  const utm_medium = utm.get("utm_medium");
  const utm_campaign = utm.get("utm_campaign");
  const utm_term = utm.get("utm_term");
  const utm_content = utm.get("utm_content");
  const utm_data = {
    utm_source,
    utm_medium,
    utm_campaign,
    utm_term,
    utm_content,
  };
  if (Object.values(utm_data).filter((item) => item).length === 0) return;
  sessionStorage.setItem("utm", JSON.stringify(utm_data));
  // remove utm from url
  window.history.replaceState({}, document.title, window.location.pathname);
}
function getUTM() {
  return JSON.parse(sessionStorage.getItem("utm")) || {};
}

function sendToSheets(e) {
  const url =
    "https://script.google.com/macros/s/AKfycbzxJnzauEkRkSbOKTbZ-hv51tzqJ5FwkE-quXyditvsZITlUH2tOgNcdsY87mZiQjvq/exec";
  fetch(url, {
    method: "POST",
    mode: "no-cors",
    body: JSON.stringify(getMessage(e, true)),
    headers: {
      "Content-Type": "application/json",
    },
  }).catch((error) => console.error("Error:", error));
}

async function sendToGPlusCRM(form) {
  const formData = new FormData(form);

  // Підготуємо дані для URLSearchParams
  const data = new URLSearchParams({
    action: "send_to_gplus_crm",
    name: formData.get("name") || "",
    phone: formData.get("phone") || "",
    email: formData.get("email") || "",
    note: formData.get("note") || "Запит з форми на сайті",
  });

  try {
    const response = await fetch(params.ajax_url, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: data,
    });

    const result = await response.json();
    console.log(result);

    if (result.success) {
      console.log("Заявка успішно додана в CRM:", result.data);
    } else {
      console.warn("Помилка при відправці в CRM:", result.data);
      alert(result.data.message || "Помилка при відправці заявки в CRM");
    }
  } catch (err) {
    console.error("Помилка з’єднання з CRM:", err);
    alert("Не вдалося з’єднатися з CRM. Спробуйте пізніше.");
  }
}
